export enum OrderType {
  送機 = "out",
  接機 = "in",
  接送 = "point_to_point"
}

export enum DriverStatus {
  未驗證,
  已驗證,
  停用中
}

export enum OrderStatus {
  派車中,
  已派車,
  已取消,
  已出發,
  載客中,
  已完成,
  已退款
}

export enum OrderActionType {
  Next,
  Abort,
  ReAssign,
  Cancel,
  SetRentalTime,
  RefundOrder,
  PayOrder,
  DeleteOrder,
  CompleteOrder
}

export enum TeamStatus {
  未啟用,
  已啟用
}

export enum PaymentMethod {
  信用卡 = "credit_card",
  街口 = "jkopay",
  LinePay = "linepay"
}

export enum PaymentStatus {
  Initialized,
  Processing,
  Notified,
  Success,
  Failed,
  Cancelled
}

export enum UserRole {
  Admin = "admin",
  Driver = "driver",
  Rider = "rider",
  Lead = "lead"
}

export enum SourceChannel {
  Klook = "Klook",
  KKDay = "KKDay",
  官LINE = "LINEOA",
  手動 = "MANUAL"
}

export enum ChatApp {
  WhatsApp = "WhatsApp",
  FacebookMessenger = "FacebookMessenger",
  LINE = "LINE",
  Viber = "Viber",
  WeChat = "WeChat",
  X = "X",
  SnapChat = "SnapChat",
  Telegram = "Telegram",
  Signal = "Signal",
  Discord = "Discord",
  Kakao = "Kakao"
}